import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Compass, Eye, Heart, Sparkles } from "lucide-react";

export default function MisyonVizyon() {
  return (
    <>
      <PageHeader
        eyebrow="Kurumsal"
        title="Misyon & Vizyon"
        description="Bizi yarına taşıyan değerler ve hedefler."
      />
      <section className="py-20 md:py-28">
        <div className="max-w-5xl mx-auto px-5 lg:px-8">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-10 rounded-2xl bg-slate-950 text-white relative overflow-hidden">
              <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-brand-gold/15 blur-3xl" />
              <div className="relative">
                <Compass className="w-8 h-8 text-brand-gold mb-6" />
                <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">
                  Misyonumuz
                </div>
                <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight mb-5">
                  Güveni hizmet olarak sunmak.
                </h2>
                <p className="text-slate-300 leading-relaxed">
                  Müşterilerimize en güncel piyasa kurlarıyla, şeffaf, hızlı ve güvenilir döviz alım-satım
                  hizmeti sunmak; finansal okuryazarlığa katkı sağlayan, etik değerlerden ödün vermeyen
                  bir kurum olarak Yalova'nın ekonomik hayatına değer katmak.
                </p>
              </div>
            </div>

            <div className="p-10 rounded-2xl bg-white border border-slate-200 relative overflow-hidden">
              <Eye className="w-8 h-8 text-brand-gold mb-6" />
              <div className="text-[11px] uppercase tracking-[0.25em] text-brand-gold font-bold mb-3">
                Vizyonumuz
              </div>
              <h2 className="font-display text-3xl md:text-4xl font-bold tracking-tight text-slate-950 mb-5">
                Marmara'nın referans döviz markası.
              </h2>
              <p className="text-slate-600 leading-relaxed">
                Teknolojiyi geleneksel hizmet kalitesiyle harmanlayarak, sadece Yalova'nın değil, tüm
                Marmara Bölgesi'nin tercih ettiği, dijital ve fiziksel kanallarda kesintisiz hizmet
                veren öncü döviz markası olmak.
              </p>
            </div>
          </div>

          <h3 className="font-display text-2xl md:text-3xl font-bold text-slate-950 mt-20 mb-8 tracking-tight">
            Temel Değerlerimiz
          </h3>

          <div className="grid md:grid-cols-3 gap-5">
            {[
              { icon: <Heart className="w-5 h-5" />, t: "Müşteri Odaklılık", d: "Her müşterimizi özel görür, ihtiyaçlarına özel çözümler üretiriz." },
              { icon: <Sparkles className="w-5 h-5" />, t: "Şeffaflık", d: "İşlemlerimizde gizli bir adım yoktur. Her adımı açıkça paylaşırız." },
              { icon: <Compass className="w-5 h-5" />, t: "Etik Liderlik", d: "Yasalara, ahlaka ve evrensel değerlere bağlı kalırız." },
            ].map((v, i) => (
              <div key={i} className="p-7 rounded-xl bg-slate-50 border border-slate-200 hover:bg-white hover:border-brand-gold/40 transition-all">
                <div className="text-brand-gold mb-3">{v.icon}</div>
                <h4 className="font-display font-bold text-slate-950 mb-2">{v.t}</h4>
                <p className="text-sm text-slate-600 leading-relaxed">{v.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
